<template>
  <li
    class="
      h-max overflow-hidden rounded-bl-2xl border
      border-[var(--navigation-item-border-color)]
      bg-[var(--navigation-item-background-color)]
      text-[var(--navigation-item-text-color)]
    "
  >
    <button
      v-if="navItem.children.length"
      type="button"
      class="
        flex min-h-9 w-full items-center justify-between pl-3 pr-1 text-left
        font-bold
        md:py-0
      "
      :class="{'pr-3': !navItem.children.length}"
      @click="handleItemToggle"
    >
      <div class="w-fit whitespace-nowrap">
        {{ navItem.page.title }}
      </div>

      <PlusMinus
        :is-minus="level1Open"
        :color-plus="buttonIconColor"
        :color-minus="buttonIconColor"
        class="ml-1"
      />
    </button>
    <DesktopNavigationLink
      v-else
      class="
        flex min-h-9 w-full items-center justify-between pl-3 text-left
        font-bold
        md:py-0
      "
      :class="isExternal ? 'pr-3' : 'pr-1'"
      :to="navItem.page.url"
    >
      {{ navItem.page.title }}
    </DesktopNavigationLink>
    <ul
      class="max-w-[15.5rem] overflow-hidden px-3"
      :class="[
        level1Open
          ? 'max-h-192 pb-3 transition-[max-height] duration-500 ease-out'
          : 'max-h-0 opacity-10 transition-all duration-250 ease-in',
      ]"
    >
      <li
        v-for="(level2NavItem) in navItem.children"
        :key="level2NavItem.page.id"
        class="mt-1.5 leading-tight transition-colors"
        :class="openChildId && openChildId !== level2NavItem.page.id ? `
          text-gray-300 duration-300 ease-out
        ` : 'duration-500 ease-in'"
      >
        <DesktopNavigationLink
          v-if="!level2NavItem.children.length"
          :to="level2NavItem.page.url"
          :tabindex="level1Open ? 0 : -1"
        >
          {{ level2NavItem.page.title }}
        </DesktopNavigationLink>
        <DesktopNavigationCollapseLevel2
          v-else
          :nav-item="level2NavItem"
          :open="openChildId === level2NavItem.page.id || false"
          :parent-open="level1Open"
          @toggle="handleChildToggle(level2NavItem.page.id)"
        />
      </li>
    </ul>
  </li>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'

const route = useRoute()
const theme = useTheme()

const isMounted = ref(false)

const props = defineProps({
  navItem: {
    type: Object,
    required: true,
  },
})

const level1Open = ref(false)
const openChildId = ref<string>('')

function handleItemToggle() {
  level1Open.value = !level1Open.value
}

function handleChildToggle(id: string) {
  openChildId.value = openChildId.value !== id ? id : ''
}

watch(() => route.fullPath, () => {
  level1Open.value = false
  openChildId.value = ''
})

const isExternal = computed(() => {
  return typeof props.navItem.page.url === 'string' ? isExternalUrl(props.navItem.page.url) : false
})

const buttonIconColor = computed(() => {
  if (theme.value === 'integrity') {
    return 'white'
  }
  return 'red'
})

onMounted(() => {
  isMounted.value = true // prevent visibility on load
})
</script>

<style>
/* Use CSS variables because like this the colors switch before the component is mounted completely */
:root {
  --navigation-item-border-color: rgb(var(--color-red-500));
  --navigation-item-text-color: black;
  --navigation-item-background-color: transparent;
}

[data-theme="integrity"] {
  --navigation-item-border-color: rgb(var(--color-red-500));
  --navigation-item-text-color: white;
  --navigation-item-background-color: rgb(var(--color-red-500));
}
</style>
